import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaGreaterThanEqual } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var GreaterEqual = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'greaterEqual',
    description: 'Check if a amount1 is greater or equal to amount2',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                valueToCheck: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaGreaterThanEqual }),
                decimals1: new FctDecimals({}),
                threshold: new FctValue({ destination: 'wei_amount', isPreview: true }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                description: 'amount1 - amount2',
                innerIndex: 0,
            }),
        },
    }); },
});
